"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputFieldStyles = void 0;
var core_1 = require("@material-ui/core");
var style_1 = require("../../../style");
exports.useInputFieldStyles = core_1.makeStyles(function () { return ({
    textField: {
        paddingBottom: 24,
    },
    inputLabel: {
        padding: 0,
        zIndex: 'auto',
        position: 'relative',
        transform: 'translate(0,0)',
        color: style_1.darkBlue,
        fontSize: 14,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '17px',
        letterSpacing: 'normal',
        marginBottom: 4,
        '&$inputLabelShrink': {
            transform: 'translate(0,0) scale(1)',
        },
        '&$inputLabelFocused': {
            color: style_1.darkBlue,
        },
    },
    inputLabelShrink: {},
    inputLabelFocused: {},
    inputLabelError: {
        color: style_1.darkBlue,
    },
    inputLabelRequiredDecorator: {
        position: 'relative',
        left: -1,
    },
    inputBase: {
        border: 0,
        borderRadius: 0,
        height: '40px',
        '&$inputBaseFocused': {},
        '&$inputBaseDisabled': {},
    },
    inputBaseFocused: {},
    inputBaseDisabled: {},
    inputBaseError: {
        '& > input': {
            borderColor: style_1.mediumRed,
        },
    },
    input: {
        color: style_1.darkBlue,
        fontSize: 16,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        border: "solid 1px " + style_1.mediumLightBlue,
        borderRadius: 4,
        backgroundColor: 'white',
        height: 38,
        padding: '0 12px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        '&::placeholder': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            color: style_1.mediumLightBlue,
            opacity: 1,
        },
        '&:-ms-input-placeholder': {
            fontStyle: 'normal',
            color: style_1.mediumLightBlue,
            opacity: 1,
        },
        '& + fieldset': {
            display: 'none',
        },
    },
    errorHelperText: {
        position: 'absolute',
        bottom: 7,
        margin: 0,
        fontSize: 12,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: style_1.mediumRed,
    },
}); });
